import { Link } from 'react-router-dom';
import { LinkedInIcon } from '../common/Icons';
import styles from './Footer.module.css';

const primaryLinks = [
  { label: 'Capabilities', path: '/capabilities' },
  { label: 'About', path: '/about' },
  { label: 'Sign in', path: '/request' },
];

const legalLinks = [
  { label: 'Privacy', path: '/privacy' },
  { label: 'Cookies', path: '/cookies' },
  { label: 'Legal', path: '/legal' },
];

const LINKEDIN_URL = 'https://linkedin.com/company/aedraco/';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className={styles.footer} role="contentinfo">
      <div className={styles.container}>
        <div className={styles.topRow}>
          <Link to="/" className={styles.brand} aria-label="Aedra home">
            <img
              src="/logo.svg"
              alt=""
              className={styles.logoImage}
              aria-hidden="true"
              onError={(e) => {
                const target = e.target as HTMLImageElement;
                if (target.src.includes('logo.svg')) {
                  target.src = '/png.png';
                }
              }}
            />
            <span className={styles.brandName}>Aedra</span>
          </Link>

          <p className={styles.statement}>
            Private-market research for PE, venture, and M&amp;A teams.
          </p>

          <div className={styles.actions}>
            <a
              href={LINKEDIN_URL}
              className={styles.socialLink}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Aedra on LinkedIn"
            >
              <LinkedInIcon size={20} />
            </a>
            <Link to="/request" className={styles.cta}>
              Sign in
            </Link>
          </div>
        </div>

        <div className={styles.bottomRow}>
          <nav className={styles.linkRow} aria-label="Footer">
            {primaryLinks.map((link) => (
              <Link key={link.path} to={link.path} className={styles.link}>
                {link.label}
              </Link>
            ))}
            <span className={styles.divider} aria-hidden="true" />
            {legalLinks.map((link) => (
              <Link key={link.path} to={link.path} className={styles.linkMuted}>
                {link.label}
              </Link>
            ))}
          </nav>

          <p className={styles.copyright}>© {currentYear} Aedra</p>
        </div>
      </div>
    </footer>
  );
}
